import type {
  AppModulesUserCatalogEnumsPublishingStatus,
  AvailabilityStatus,
  LabelKind,
} from '@/api/generated/schemas';

export const availabilityStatusColors: Record<AvailabilityStatus, string> = {
  coming_soon: 'blue',
  early_access: 'purple',
  new_release: 'cyan',
  recently_added: 'green',
  leaving_soon: 'gold',
  available: 'green',
  unavailable: 'red',
};

export const publicationPublishingStatusColors: Record<
  AppModulesUserCatalogEnumsPublishingStatus,
  string
> = {
  draft: 'default',
  scheduled: 'blue',
  published: 'green',
  withdrawn: 'orange',
  archived: 'red',
};

export const labelColors: Partial<Record<LabelKind, string>> = {
  exclusive: 'purple',
  top: 'blue',
};
